<template>
  <div class="line-popup">
    <p class="popup-header">{{ data.path}} </p>
    <table class="table table-sm table-bordered">
      <tr><td>device</td><td>{{ data.device }}</td></tr>
      <tr><td>owner</td><td>{{ data.owner }}</td></tr>
      <tr><td>contract</td><td>{{ data.contract }}</td></tr>
      <tr><td>containers</td><td>{{ data.count }}</td></tr>
      <tr><td>lifted containers</td><td>{{ data.lifted }}</td></tr>
      <tr><td>percent</td><td>{{ data.percent }}%</td></tr>
      <tr><td>line last update</td><td>{{ data.linelastupdate }}</td></tr>
      <tr><td>tag</td><td>{{ data.tag }}</td></tr>
      <tr><td>code</td><td>{{ data.code }}</td></tr>
      <tr><td>lastupdate</td><td>{{ data.lastupdate }}</td></tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  }
};
</script>

<style lang="scss">

.popup-header {
  text-align: center;
  background-color: #27afba;
  padding:10px 0 10px 0;
  margin: 0 !important;
}

.line-popup {
  border: 1px solid #27afba;
}
</style>